import {
    CreateTRPCProxyClient,
    createTRPCProxyClient,
    httpLink,
    // loggerLink
} from '@trpc/client';
import { TrpcAppRouterType } from 'src_server/trpc/TrpcRouter';
import { arrayBufferToString } from './TrpcClient/arrayBuffer';
import { Session } from 'src_common/sdk/session';
import { TrpcUploadCsvResponseType } from 'src_server/trpc/NewTrading';
import { TrpcLiabilitiesInputSchemaType } from 'src_server/types';

export class TrpcClient {
    public readonly client: CreateTRPCProxyClient<TrpcAppRouterType>;

    public constructor(private readonly session: Session) {
        this.client = createTRPCProxyClient<TrpcAppRouterType>({
            links: [
                // loggerLink<TrpcAppRouterType>(),
                httpLink<TrpcAppRouterType>({
                    url: '/trpc',
                    headers: () => {
                        const currentJwt = this.session.currentJwt;
                        return {
                            Authorization: currentJwt,
                        };
                    },
                }),
            ],
        });
    }

    public async csvUpload(file: File): Promise<TrpcUploadCsvResponseType> {
        const name = file.name;
        const data = await file.arrayBuffer();

        return await this.client.newTrading.uploadCsv.mutate({
            name,
            data: arrayBufferToString(data),
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    public async getSinglesLiabilities(input: TrpcLiabilitiesInputSchemaType) {
        return await this.client.liabilities.getSinglesLiabilities.query({
            ...input,
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    public async getMultiplesLiabilities(input: TrpcLiabilitiesInputSchemaType) {
        return await this.client.liabilities.getMultiplesLiabilities.query({
            ...input,
        });
    }

    public async reassignTraderChat(chatId: number): Promise<void> {
        return await this.client.traderChat.reassignChat.query({
            chatId,
        });
    }

    public async getBetBuilderPrice(
        geniusMarketId: string,
        stake: number
    ): Promise<{ type: 'expired' } | { type: 'suspended' } | { type: 'error' } | { type: 'ok'; data?: unknown }> {
        return await this.client.betBuilder.getPrice.query({
            geniusMarketId,
            stake,
        });
    }
}
